import { render, staticRenderFns } from "./i-loader.vue?vue&type=template&id=7c929a84&scoped=true&"
import script from "./i-loader.vue?vue&type=script&lang=js&"
export * from "./i-loader.vue?vue&type=script&lang=js&"
import style0 from "./i-loader.vue?vue&type=style&index=0&id=7c929a84&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c929a84",
  null
  
)

export default component.exports